import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Edit,
	Create,
	Crud,
	trans
} from '@/router/index'

import Task from '@/components/modules/tasks/Task'
import TasksSettings from '@/components/modules/tasks/settings/TasksSettings'

export const tasks = [
	{ 
		path: '/tasks', 
		component: AppTabs,
		beforeEnter: ifAuthenticated,
		props: {
			tabs: [
				{
					to: '/tasks/',
					text: 'Task',
				},
			],
		},
		children: [
			{
				path: '/tasks/',
				meta: {
					title: trans('task')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'tasks',
					actionIcon: 'dns',
					title: 'Task',
					styleClass: 'mb-offset'
				}
			},		
		],
	},
	{
		path: '/tasks/create',
		name: 'tasks-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'tasks',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/tasks/:id/edit',
		name: 'tasks-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'tasks',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/tasks/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/tasks/' + parseInt(route.params.id) + '/',
					text: 'Task',
				},
			]
		}),
		children: [
			{
				path: '',
				name: 'tasks-show', 
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'task', next) },
				component: Task,
				meta: {
					title: 'Task'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
				}), 
			},
		]		
	},
	{
		path: '/settingstasks/',
		name: 'settingstasks',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingstasks',
					text: 'Task',
				},
			],
		},
		children: [
			{
				path: '/settingstasks/',
				beforeEnter: ifAuthenticatedOnline,
				component: TasksSettings,
			},
		],
	},
]